<template>
  <v-container fluid>
    <v-row class="mb-5">
      <v-col>
        <span class='font-16 font-w-700'>สรุปรายละเอียดโปรโมชัน ณ ร้าน Café Amazon  ประจำสัปดาห์ของเดือน{{dateStr}}</span>
        <DisplayBtn v-model="display"/>
      </v-col>
    </v-row>
    <v-card rounded outlined>
      <v-container fluid>
        <v-row class="text-right row-header flex-nowrap">
          <v-col
            v-for="(day, i) in days"
            :key="`hday-${i}`"
            :class="`py-3 ${day.class}`">
            <span class="d-none d-sm-inline">{{day.dddd}}</span>
            <span class="d-sm-none">{{day.dd}}</span><br>
            <v-avatar
              :color="day.isCur ? '#F1545B' : ''"
              :class="day.isCur ? 'active' : ''"
              size="24">{{day.D}}</v-avatar>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid class="pa-0">
        <v-row no-gutters class="content">
          <v-col class="promo-calendar week">
            <v-container fluid fill-height class="pa-0">
              <v-row no-gutters class="fill-height flex-nowrap">
                <v-col
                  v-for="i in Array(7).keys()"
                  :key="`bar-bg-${i}`"
                  :class="[5,6].includes(i)? 'weekend' : ''">
                  <v-container fluid fill-height/>
                </v-col>
              </v-row>
            </v-container>
            <template v-for="(color, name) in types">
              <div
                v-for="promotion in promotionsByType(name)"
                :key="`bar-${promotion.Id}`"
                :ref="`bar-${promotion.Id}`"
                class="bar px-2 font-12 font-weight-500"
                :style="{'background-color': color}">
                {{promotion.PromotionName__c}}
              </div>
            </template>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import DisplayBtn from '@/components/calendar/sub/DisplayBtn.vue'

export default {
  components: { DisplayBtn },
  data() {
    return {
      display: 'calendar',
    }
  },
  props: {
    promotions: { types: Array, require: true },
    form: { types: Object, require: true },
  },
  mounted() {
    this.$nextTick(this.calBar)
  },
  watch:{
    display(newVal) {
      this.$emit('changeDisplay', newVal)
    },
    promotions() {
      this.$nextTick(this.calBar)
    },
  },
  methods: {
    promotionsByType(type) {
      return this.promotions.filter(promotion => promotion.PromotionType__c == type)
    },
    dateFirst(){
      const date = moment(new Date(this.form.year, this.form.month, this.form.day))
      date.subtract((date.day()+6)%7, 'day')
      return date
    },
    calBar() {
      const first = this.dateFirst()
      const last = this.dateFirst().add(6, 'day')
      this.promotions.forEach((promotion, i) => {
        const bar = this.$refs[`bar-${promotion.Id}`][0]
        let top = 0, left = 0, right = 0

        top = i * 18

        const start = moment(promotion.StartDate__c)
        if (start >= first) {
          const diff = start.diff(first, 'day')
          left = Math.min((100 * diff / 7), 100)
          bar.style['border-bottom-left-radius']='5px'
          bar.style['border-top-left-radius']='5px'
          bar.style['margin-left']='2px'
        }else{
          bar.style['border-bottom-left-radius']='0px'
          bar.style['border-top-left-radius']='0px'
          bar.style['margin-left']='0px'
        }

        const end = 'EndDate__c' in promotion ? moment(promotion.EndDate__c) : false
        if (end && end <= last) {
          const diff = last.diff(end, 'day')
          right = Math.min((100 * diff / 7), 100)
          bar.style['border-bottom-right-radius']='5px'
          bar.style['border-top-right-radius']='5px'
          bar.style['margin-right']='2px'
        }else{
          bar.style['border-bottom-right-radius']='0px'
          bar.style['border-top-right-radius']='0px'
          bar.style['margin-right']='0px'
        }

        bar.style.top=`${top}px`
        bar.style.left=`${left}%`
        bar.style.right=`${right}%`
      });
    },
  },
  computed: {
    ...mapGetters({
      types: 'Calendar/getTypes',
    }),
    dateStr() {
      const date = new Date(this.form.year, this.form.month, this.form.day)
      return moment(date).format('MMMM') + ' ' + (this.form.year + 543)
    },
    days() {
      const today = new Date()
      const date = this.dateFirst().subtract(1, 'day')
      return [...Array(7).keys()].map(day => {
        date.add(1, 'day')
        return {
          'dd': date.format('dd').replace('.', ''),
          'dddd': date.format('dddd'),
          'D': date.format('D'),
          'isCur': date.isSame(today, 'day'),
          'class': [0,6].includes(date.day()) ? 'weekend' : '',
        }
      })
    },
  }
};
</script>
